<template>
    <fieldset
        :class="{'opacity-60': blockEdit}"
    >
        <legend class="sr-only">
            {{ inputSlug }}
        </legend>
        
        <div class="relative flex items-start">
            <div class="flex items-center h-5">
                <input
                    :id="inputSlug"
                    v-model="input"
                    aria-describedby="comments-description"
                    :type="type"
                    :name="inputSlug"
                    :disabled="blockEdit"
                    :placeholder="placeholder"
                    :class="[
                        'h-4 w-4 rounded ml-1',
                        'chat_transition outline-none focus:ring-2 focus:ring-chat-primary focus:border-chat-primary',
                        'dark:bg-neutral-400 dark:ring-offset-neutral-600',
                        'checked:bg-chat-primary dark:checked:bg-chat-primary',
                        {'mt-3': description},
                        {'cursor-no-drop': blockEdit}
                    ]"
                    @change="$emit('update:modelValue', input)"
                >
            </div>
            
            <div class="ml-3 text-sm">
                <label
                    :for="inputSlug"
                    class="font-medium text-gray-900 dark:text-gray-400"
                    v-html="label"
                />

                <p
                    v-if="description"
                    id="comments-description"
                    class="text-gray-400"
                >
                    {{ description }}
                </p>
            </div>
        </div>
    </fieldset>
</template>

<script>
    import {str_slug} from '@/utils/string'

    export default {
        // eslint-disable-next-line vue/match-component-file-name
        name: 'InputCheckBoxWithDescription',

        props: {
            label: {
                type: String,
                default: '',
                required: true,
            },
            type: {
                type: String,
                default: 'checkbox',
            },
            description: {
                type: String,
                default: '',
            },
            placeholder: {
                type: String,
                default: '',
            },
            rules: {
                type: String,
                default: '',
            },
            blockEdit: {
                type: Boolean,
                default: false,
            },
            modelValue: {
                type: [Boolean, String],
                default: false,
            },
        },

        emits: ['update:modelValue'],
        
        data() {
            return {
                input: this.modelValue,
            };
        },

        computed: {
            inputSlug() {
                return str_slug(this.label)
            },
        },
        watch: {
            modelValue: {
                handler(val) {
                    this.input = val
                },
            },
        },
    }
</script>